import { Component } from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import * as selectors from "src/modules/avatar/duck/selectors";
import { withParentStation } from "src/modules/parent-station/ParentStation/Context";
import Flow from "src/components/Flow";

import NoAvatars from "../scenes/NoAvatars";
import AvatarEditor from "../scenes/Editor";
import AvatarList from "../scenes/AvatarList";

class AvatarsFlow extends Component {
  state = {
    initialStep: this.props.initialStep || "avatars"
  };

  steps = [
    {
      id: "avatars",
      Component: ({ flow, onClose, onBack }) => {
        const avatarsArray = this.getAvatarsArray().reverse();
        return avatarsArray.length === 0 ? (
          <NoAvatars
            onClose={onClose}
            onBack={onBack}
            openEditor={() =>
              flow.push("editor", { state: { avatarId: null } })
            }
          />
        ) : (
          <AvatarList
            avatars={avatarsArray}
            onClose={onClose}
            onBack={onBack}
            openEditor={(avatarId) =>
              flow.push("editor", { state: { avatarId } })
            }
          />
        );
      }
    },
    {
      id: "editor",
      Component: ({
        onClose,
        onBack,
        flow,
        initialStep,
        avatars,
        parentStation,
        defaultAvatarId,
        shouldCloseOnSave
      }) => {
        function redirect() {
          shouldCloseOnSave
            ? onBack()
            : flow.push("avatars", { direction: "previous" });
        }
        const avatar = avatars[flow.state.avatarId];

        return (
          <AvatarEditor
            onClose={onClose}
            onBack={initialStep === "editor" ? onBack : flow.previous}
            afterDelete={(avatarId) => {
              if (avatarId === defaultAvatarId && parentStation) {
                const newDefaultAvatar = this.getAvatarsArray().filter(
                  (avatar) => avatar.objectId !== defaultAvatarId
                )[0];
                newDefaultAvatar &&
                  parentStation.switchAvatar(newDefaultAvatar.objectId);
              }
              redirect();
            }}
            afterSave={(avatarId) => {
              const isNewAvatar = avatar == null;
              if (isNewAvatar && parentStation) {
                parentStation.switchAvatar(avatarId);
              }
              redirect();
            }}
            avatar={avatar}
          />
        );
      }
    }
  ];

  compareDates(date1, date2) {
    if (new Date(date1.birthDate) < new Date(date2.birthDate)) {
      return -1;
    }
    if (new Date(date1.birthDate) > new Date(date2.birthDate)) {
      return 1;
    }
    return 0;
  }

  getAvatarsArray() {
    const { avatars } = this.props;
    let filteredAvatars = Object.values(avatars).filter(
      (avatar) => avatar.deleted === false
    );
    filteredAvatars.sort(this.compareDates);
    return filteredAvatars;
  }

  render() {
    const { initialStep } = this.state;
    const { avatars, defaultAvatarId, ...rest } = this.props;

    return (
      <Flow
        avatars={avatars}
        initialStep={initialStep}
        steps={this.steps}
        defaultAvatarId={defaultAvatarId}
        {...rest}
      />
    );
  }
}

function mapStateToProps(state) {
  const avatars = selectors.getAvatars(state);
  const defaultAvatarId = selectors.getDefaultAvatarId(state);

  return {
    avatars,
    defaultAvatarId
  };
}

const enhance = compose(withParentStation, connect(mapStateToProps));

export default enhance(AvatarsFlow);
